export const comics = [
  {
    id: 'xingguang',
    title: '她的眼眸有星光',
    author: '柚见',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20close%20together%20under%20starlight%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20tender%20romantic%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-xingguang-01&orientation=portrait',
    description: '天文社的夏夜里，沉默寡言的转学生林昭遇见了总把星空讲得闪闪发光的学姐苏晚。一次流星雨许愿，让两条原本平行的轨道悄然靠近。她们在观星台交换秘密，也在城市灯火里确认彼此的名字。',
    category: 'romance',
    tags: ['校园', '治愈', '慢热'],
    status: '连载',
    year: 2025,
    latestChapter: '第42话 · 流星归位',
    updateDate: '2026-10-12',
    rating: 9.4,
    views: '312万',
    popularity: 100,
    chapters: [
      { id: 'c1', title: '第1话 · 转学生与望远镜', date: '2026-03-02' },
      { id: 'c2', title: '第2话 · 天台上的星座图', date: '2026-03-16' },
      { id: 'c3', title: '第3话 · 学姐的秘密笔记', date: '2026-04-06' },
      { id: 'c4', title: '第4话 · 雨天共撑一把伞', date: '2026-05-11' },
      { id: 'c5', title: '第5话 · 文化祭的投影仪', date: '2026-06-20' },
      { id: 'c6', title: '第6话 · 观星台的那句话', date: '2026-08-01' },
      { id: 'c7', title: '第7话 · 夏末没有说出口', date: '2026-09-14' },
      { id: 'c8', title: '第42话 · 流星归位', date: '2026-10-12' },
    ],
  },
  {
    id: 'xiamo',
    title: '夏末的风与你的裙摆',
    author: '橘子海',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20in%20school%20uniforms%20on%20a%20breezy%20summer%20schoolyard%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20youthful%20summer%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-xiamo-01&orientation=portrait',
    description: '高二的夏天，篮球队长周晴和美术社的安静少女许知在同一间教室值日。粉笔灰、蝉鸣与风扇转动的声音里，一场从争吵开始的靠近，慢慢变成了谁也不愿结束的夏天。',
    category: 'campus',
    tags: ['校园', '青春', '欢喜冤家'],
    status: '连载',
    year: 2025,
    latestChapter: '第38话 · 蝉鸣落幕',
    updateDate: '2026-10-10',
    rating: 9.1,
    views: '268万',
    popularity: 96,
    chapters: [
      { id: 'c1', title: '第1话 · 值日表上的名字', date: '2026-02-18' },
      { id: 'c2', title: '第2话 · 被篮球砸中的素描本', date: '2026-03-05' },
      { id: 'c3', title: '第3话 · 体育馆的和解', date: '2026-03-28' },
      { id: 'c4', title: '第4话 · 一起翘掉的自习课', date: '2026-04-22' },
      { id: 'c5', title: '第5话 · 画展前的加班', date: '2026-06-02' },
      { id: 'c6', title: '第6话 · 运动会接力棒', date: '2026-07-15' },
      { id: 'c7', title: '第7话 · 天台风很大', date: '2026-08-26' },
      { id: 'c8', title: '第38话 · 蝉鸣落幕', date: '2026-10-10' },
    ],
  },
  {
    id: 'shuanghua',
    title: '魔法学院的双生花',
    author: '夜莺与灯',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20sorceresses%20casting%20glowing%20magic%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20castle%20background%2C%20expressive%20line%20art%2C%20enchanting%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-shuanghua-01&orientation=portrait',
    description: '在悬浮于云端的阿尔文魔法学院，优等生薇拉与自学成才的转校生诺娅被分到了同一间双人宿舍。一个遵循规则，一个挑战规则，而当禁书区的封印开始松动，她们必须在彼此身上找到对抗黑暗的力量。',
    category: 'fantasy',
    tags: ['奇幻', '魔法', '冒险'],
    status: '连载',
    year: 2024,
    latestChapter: '第64话 · 封印之下',
    updateDate: '2026-10-13',
    rating: 9.6,
    views: '489万',
    popularity: 99,
    chapters: [
      { id: 'c1', title: '第1话 · 会飞的入学信', date: '2024-09-01' },
      { id: 'c2', title: '第2话 · 双人宿舍的规矩', date: '2024-10-12' },
      { id: 'c3', title: '第3话 · 第一次魔咒考试', date: '2025-01-08' },
      { id: 'c4', title: '第4话 · 禁书区的猫', date: '2025-04-20' },
      { id: 'c5', title: '第5话 · 云梯上的对峙', date: '2025-08-16' },
      { id: 'c6', title: '第6话 · 共享的魔力回路', date: '2026-01-25' },
      { id: 'c7', title: '第7话 · 星象塔的预言', date: '2026-06-09' },
      { id: 'c8', title: '第64话 · 封印之下', date: '2026-10-13' },
    ],
  },
  {
    id: 'wanfeng',
    title: '都市晚风录',
    author: '林间有雨',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20in%20stylish%20city%20outfits%20on%20a%20rooftop%20at%20dusk%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20skyline%20background%2C%20expressive%20line%20art%2C%20urban%20evening%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-wanfeng-01&orientation=portrait',
    description: '广告公司的加班狂人程晚，和隔壁深夜花店老板娘季岚，因为一部总在凌晨响起的电梯而熟络。都市很大，孤独很轻，两个习惯了独自撑伞的人，在无数个晚风里学会了并肩。',
    category: 'urban',
    tags: ['都市', '职场', '治愈'],
    status: '连载',
    year: 2025,
    latestChapter: '第30话 · 凌晨的电梯',
    updateDate: '2026-10-08',
    rating: 9.0,
    views: '201万',
    popularity: 90,
    chapters: [
      { id: 'c1', title: '第1话 · 凌晨一点的电梯', date: '2026-01-05' },
      { id: 'c2', title: '第2话 · 花店打烊时间', date: '2026-02-14' },
      { id: 'c3', title: '第3话 · 提案被否的那天', date: '2026-03-20' },
      { id: 'c4', title: '第4话 · 一起吃的泡面', date: '2026-04-28' },
      { id: 'c5', title: '第5话 · 天台上的烟花', date: '2026-06-18' },
      { id: 'c6', title: '第6话 · 谁先动的心', date: '2026-08-09' },
      { id: 'c7', title: '第7话 · 搬家的纸箱', date: '2026-09-21' },
      { id: 'c8', title: '第30话 · 凌晨的电梯', date: '2026-10-08' },
    ],
  },
  {
    id: 'huadian',
    title: '花店与咖啡屋',
    author: '软糖小姐',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20in%20a%20cozy%20flower%20shop%20and%20cafe%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20warm%20healing%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-huadian-01&orientation=portrait',
    description: '老街的转角，一半是花店一半是咖啡屋。花艺师温梨和咖啡师安可共用一面墙，也在同一个屋檐下分享客人的故事。四季更迭，她们把平凡的每一天，都过成了温柔的诗。',
    category: 'healing',
    tags: ['治愈', '日常', '美食'],
    status: '完结',
    year: 2024,
    latestChapter: '第50话 · 四季如你',
    updateDate: '2026-07-30',
    rating: 9.3,
    views: '356万',
    popularity: 92,
    chapters: [
      { id: 'c1', title: '第1话 · 共用一面墙', date: '2024-05-06' },
      { id: 'c2', title: '第2话 · 第一束向日葵', date: '2024-07-18' },
      { id: 'c3', title: '第3话 · 拿铁上的拉花', date: '2024-09-25' },
      { id: 'c4', title: '第4话 · 秋天的银杏', date: '2024-11-30' },
      { id: 'c5', title: '第5话 · 圣诞夜的歌', date: '2024-12-24' },
      { id: 'c6', title: '第6话 · 早春的第一支郁金香', date: '2025-03-15' },
      { id: 'c7', title: '第7话 · 老街要拆迁了', date: '2025-06-28' },
      { id: 'c8', title: '第50话 · 四季如你', date: '2026-07-30' },
    ],
  },
  {
    id: 'diqifengxin',
    title: '迷雾里的第七封信',
    author: '灰调',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20detectives%20in%20a%20misty%20alley%20holding%20a%20letter%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20muted%20background%2C%20expressive%20line%20art%2C%20mysterious%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-diqifengxin-01&orientation=portrait',
    description: '记者沈屿收到六封没有寄件人的匿名信，第七封却寄到了刚搬来的邻居、前法医顾清家里。两人被卷进一桩尘封十年的旧案，每解开一个线索，就更靠近彼此，也更靠近危险。',
    category: 'suspense',
    tags: ['悬疑', '推理', '都市'],
    status: '连载',
    year: 2026,
    latestChapter: '第22话 · 第七封信',
    updateDate: '2026-10-11',
    rating: 9.5,
    views: '274万',
    popularity: 94,
    chapters: [
      { id: 'c1', title: '第1话 · 没有寄件人的信', date: '2026-04-02' },
      { id: 'c2', title: '第2话 · 隔壁搬来的邻居', date: '2026-04-19' },
      { id: 'c3', title: '第3话 · 旧案卷宗', date: '2026-05-23' },
      { id: 'c4', title: '第4话 · 雨夜的跟踪者', date: '2026-06-27' },
      { id: 'c5', title: '第5话 · 法医的直觉', date: '2026-07-31' },
      { id: 'c6', title: '第6话 · 证物室的灯', date: '2026-08-24' },
      { id: 'c7', title: '第7话 · 谁在说谎', date: '2026-09-19' },
      { id: 'c8', title: '第22话 · 第七封信', date: '2026-10-11' },
    ],
  },
  {
    id: 'changan',
    title: '长安月下卿',
    author: '青砚',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20in%20elegant%20traditional%20robes%20under%20a%20full%20moon%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20classical%20romantic%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-changan-01&orientation=portrait',
    description: '长安城的灯会之上，女扮男装的画师柳砚遇见了舞剑的乐坊主事齐月。一盏花灯、一句玩笑，让两个身份悬殊的女子结下难解的缘分。朝堂风云与儿女情长交织，她们能否守住那轮共看的月？',
    category: 'history',
    tags: ['古风', '言情', '权谋'],
    status: '连载',
    year: 2024,
    latestChapter: '第56话 · 长安月下卿',
    updateDate: '2026-10-05',
    rating: 9.2,
    views: '398万',
    popularity: 93,
    chapters: [
      { id: 'c1', title: '第1话 · 灯会初遇', date: '2024-08-12' },
      { id: 'c2', title: '第2话 · 乐坊的舞剑', date: '2024-10-03' },
      { id: 'c3', title: '第3话 · 一幅画像', date: '2025-01-16' },
      { id: 'c4', title: '第4话 · 曲江池畔', date: '2025-05-09' },
      { id: 'c5', title: '第5话 · 宫墙之内', date: '2025-09-21' },
      { id: 'c6', title: '第6话 · 雨夜密信', date: '2026-02-27' },
      { id: 'c7', title: '第7话 · 一念之差', date: '2026-06-14' },
      { id: 'c8', title: '第56话 · 长安月下卿', date: '2026-10-05' },
    ],
  },
  {
    id: 'qigaobai',
    title: '她的第七次告白',
    author: '晚风信箱',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20sharing%20an%20umbrella%20in%20warm%20rain%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20sweet%20romantic%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-qigaobai-01&orientation=portrait',
    description: '开朗的社团干事叶恬，向冷淡的学生会长陆微告白过六次，次次被温和地拒绝。第七次，她决定不再告白，而是认真地转身——却没想到，这一次犹豫的换成了对方。',
    category: 'romance',
    tags: ['恋爱', '校园', '甜宠'],
    status: '连载',
    year: 2025,
    latestChapter: '第35话 · 第七次',
    updateDate: '2026-10-09',
    rating: 9.0,
    views: '245万',
    popularity: 89,
    chapters: [
      { id: 'c1', title: '第1话 · 第一次告白', date: '2026-01-12' },
      { id: 'c2', title: '第2话 · 被婉拒之后', date: '2026-02-08' },
      { id: 'c3', title: '第3话 · 学生会的日常', date: '2026-03-11' },
      { id: 'c4', title: '第4话 · 第六次告白', date: '2026-04-30' },
      { id: 'c5', title: '第5话 · 一起看的电影', date: '2026-06-16' },
      { id: 'c6', title: '第6话 · 雨里的伞', date: '2026-08-02' },
      { id: 'c7', title: '第7话 · 陆微的沉默', date: '2026-09-10' },
      { id: 'c8', title: '第35话 · 第七次', date: '2026-10-09' },
    ],
  },
  {
    id: 'jita',
    title: '天台上的吉他少女',
    author: '林间有雨',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20with%20a%20guitar%20on%20a%20school%20rooftop%20at%20sunset%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20youthful%20music%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-jita-01&orientation=portrait',
    description: '性格内向的转学生林夕，总在天台偷偷弹吉他。某天她发现，写词的人竟是一直坐在她后排的校刊编辑苏晴。两个害羞的灵魂，用一首没写完的歌，把心事唱给彼此听。',
    category: 'campus',
    tags: ['校园', '音乐', '治愈'],
    status: '完结',
    year: 2023,
    latestChapter: '第44话 · 未完成的歌',
    updateDate: '2026-05-20',
    rating: 9.1,
    views: '187万',
    popularity: 85,
    chapters: [
      { id: 'c1', title: '第1话 · 天台上的吉他', date: '2023-09-04' },
      { id: 'c2', title: '第2话 · 藏在琴谱里的词', date: '2023-10-27' },
      { id: 'c3', title: '第3话 · 校刊采访', date: '2023-12-15' },
      { id: 'c4', title: '第4话 · 一起排练的午后', date: '2024-02-20' },
      { id: 'c5', title: '第5话 · 校园歌手赛', date: '2024-05-08' },
      { id: 'c6', title: '第6话 · 走音的那晚', date: '2024-08-11' },
      { id: 'c7', title: '第7话 · 毕业前夜', date: '2024-11-02' },
      { id: 'c8', title: '第44话 · 未完成的歌', date: '2026-05-20' },
    ],
  },
  {
    id: 'qiangwei',
    title: '蔷薇与剑之誓',
    author: '夜莺与灯',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20warriors%20with%20a%20sword%20and%20roses%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20epic%20fantasy%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-qiangwei-01&orientation=portrait',
    description: '王国最后的骑士艾尔莎，奉命护送以剑为誓的公主莉安前往边境。一路荆棘与玫瑰，她们在一次次并肩作战中，把效忠的誓言悄悄改写成了心底的承诺。',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '战斗'],
    status: '连载',
    year: 2024,
    latestChapter: '第48话 · 蔷薇之誓',
    updateDate: '2026-10-04',
    rating: 9.4,
    views: '341万',
    popularity: 91,
    chapters: [
      { id: 'c1', title: '第1话 · 最后的骑士', date: '2024-11-01' },
      { id: 'c2', title: '第2话 · 以剑为誓的公主', date: '2025-01-19' },
      { id: 'c3', title: '第3话 · 边境的黑森林', date: '2025-03-30' },
      { id: 'c4', title: '第4话 · 玫瑰凋谢的城', date: '2025-06-22' },
      { id: 'c5', title: '第5话 · 背靠背的夜', date: '2025-09-14' },
      { id: 'c6', title: '第6话 · 王座与自由', date: '2026-01-08' },
      { id: 'c7', title: '第7话 · 一条未送出的项链', date: '2026-05-17' },
      { id: 'c8', title: '第48话 · 蔷薇之誓', date: '2026-10-04' },
    ],
  },
  {
    id: 'diantai',
    title: '深夜电台不眠人',
    author: '软糖小姐',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20in%20a%20late%20night%20radio%20studio%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20cozy%20night%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-diantai-01&orientation=portrait',
    description: '凌晨两点的电台里，主播顾声用声音陪伴所有失眠的人。而每晚准时打来电话的匿名听众「小满」，其实是白天总在楼下面包店打工的女孩。声音与声音相遇，孤独开始有了形状。',
    category: 'urban',
    tags: ['都市', '治愈', '日常'],
    status: '连载',
    year: 2025,
    latestChapter: '第28话 · 第108个夜晚',
    updateDate: '2026-10-07',
    rating: 8.9,
    views: '163万',
    popularity: 82,
    chapters: [
      { id: 'c1', title: '第1话 · 凌晨两点的电波', date: '2026-02-01' },
      { id: 'c2', title: '第2话 · 第一个来电', date: '2026-02-20' },
      { id: 'c3', title: '第3话 · 楼下的面包店', date: '2026-03-25' },
      { id: 'c4', title: '第4话 · 声音里的秘密', date: '2026-05-02' },
      { id: 'c5', title: '第5话 · 停电的直播间', date: '2026-06-11' },
      { id: 'c6', title: '第6话 · 一起听的歌', date: '2026-07-24' },
      { id: 'c7', title: '第7话 · 节目要停播了', date: '2026-09-03' },
      { id: 'c8', title: '第28话 · 第108个夜晚', date: '2026-10-07' },
    ],
  },
  {
    id: 'huashi',
    title: '画室里的春天',
    author: '橘子海',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20poster%20illustration%20of%20two%20young%20women%20painting%20together%20in%20a%20sunlit%20art%20studio%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20gentle%20spring%20mood%2C%20storybook%20cover%2C%20high%20detail&width=480&height=640&seq=hg-huashi-01&orientation=portrait',
    description: '美术考前班的画室里，坚持写实的江雪和陈默的抽象画风格格不入。一次模考失利，让两人被迫成为彼此的「互评搭档」。画笔与画布之间，她们看见了对方眼里不一样的春天。',
    category: 'healing',
    tags: ['治愈', '艺术', '校园'],
    status: '连载',
    year: 2026,
    latestChapter: '第18话 · 春天会来',
    updateDate: '2026-10-13',
    rating: 9.0,
    views: '128万',
    popularity: 80,
    chapters: [
      { id: 'c1', title: '第1话 · 画室的第一天', date: '2026-03-01' },
      { id: 'c2', title: '第2话 · 两种画风', date: '2026-03-22' },
      { id: 'c3', title: '第3话 · 互评搭档', date: '2026-04-18' },
      { id: 'c4', title: '第4话 · 弄脏的画布', date: '2026-05-25' },
      { id: 'c5', title: '第5话 · 一起看的美术馆', date: '2026-07-06' },
      { id: 'c6', title: '第6话 · 模考成绩出来那天', date: '2026-08-17' },
      { id: 'c7', title: '第7话 · 窗外开的第一朵花', date: '2026-09-20' },
      { id: 'c8', title: '第18话 · 春天会来', date: '2026-10-13' },
    ],
  },
];